/*
 * Copyright The OpenTelemetry Authors, Aspecto
 * SPDX-License-Identifier: Apache-2.0
 */

export { KafkaJsInstrumentation } from './instrumentation';
export type {
  KafkaConsumerCustomAttributeFunction,
  KafkaJsInstrumentationConfig,
  KafkaProducerCustomAttributeFunction,
  KafkajsMessage,
  MessageInfo,
} from './types';
